import React from "react"
import styled from "@emotion/styled"
import HomepageTopBanner from "components/Homepage/homepageTopBanner"

const HomepageWrapper = styled.div`
    position: relative;
    color: ${(props) => props.theme.colors.background};
    overflow: hidden;
    & h3 {
        margin-bottom: 0;
        font-weight: 400;
    }
    & h1 {
        margin-top: 0;
    }
`

function HomepageBanner({ data }) {
    return (
        <HomepageWrapper>
            <HomepageTopBanner data={data} />
        </HomepageWrapper>
    )
}

export default HomepageBanner
